/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ecommerce_Amazon_Tools_Harden_Output6Inputs */

const en_svc_ecommerce_amazon_tools_harden_output6 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Operations playbook`)
};

const ar_svc_ecommerce_amazon_tools_harden_output6 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دليل العمليات`)
};

const bn_svc_ecommerce_amazon_tools_harden_output6 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অপারেশনস প্লেবুক`)
};

const de_svc_ecommerce_amazon_tools_harden_output6 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Operations-Playbook`)
};

const es_svc_ecommerce_amazon_tools_harden_output6 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manual de operaciones`)
};

const fr_svc_ecommerce_amazon_tools_harden_output6 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manuel d'opérations`)
};

const pt_svc_ecommerce_amazon_tools_harden_output6 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manual de operações`)
};

const zh_svc_ecommerce_amazon_tools_harden_output6 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`操作手册`)
};

const tr_svc_ecommerce_amazon_tools_harden_output6 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Operasyonlar başucu kitabı`)
};

const ru_svc_ecommerce_amazon_tools_harden_output6 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пособие по операциям`)
};

const pl_svc_ecommerce_amazon_tools_harden_output6 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podręcznik operacyjny`)
};

/**
* | output |
* | --- |
* | "Operations playbook" |
*
* @param {Svc_Ecommerce_Amazon_Tools_Harden_Output6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ecommerce_amazon_tools_harden_output6 = /** @type {((inputs?: Svc_Ecommerce_Amazon_Tools_Harden_Output6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ecommerce_Amazon_Tools_Harden_Output6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ecommerce_amazon_tools_harden_output6(inputs)
	if (locale === "bn") return bn_svc_ecommerce_amazon_tools_harden_output6(inputs)
	if (locale === "de") return de_svc_ecommerce_amazon_tools_harden_output6(inputs)
	if (locale === "es") return es_svc_ecommerce_amazon_tools_harden_output6(inputs)
	if (locale === "fr") return fr_svc_ecommerce_amazon_tools_harden_output6(inputs)
	if (locale === "pt") return pt_svc_ecommerce_amazon_tools_harden_output6(inputs)
	if (locale === "zh") return zh_svc_ecommerce_amazon_tools_harden_output6(inputs)
	if (locale === "tr") return tr_svc_ecommerce_amazon_tools_harden_output6(inputs)
	if (locale === "ru") return ru_svc_ecommerce_amazon_tools_harden_output6(inputs)
	if (locale === "pl") return pl_svc_ecommerce_amazon_tools_harden_output6(inputs)
	return en_svc_ecommerce_amazon_tools_harden_output6(inputs)
});
export { svc_ecommerce_amazon_tools_harden_output6 as "svc_ecommerce-amazon-tools_HARDEN_output" }